<template>
  <v-dialog v-model="show" @keydown.esc="close" max-width="640">
    <template #activator="{ on, attr }">
      <v-btn text color="primary" v-on="on" v-bind="attr">
        <v-icon left>mdi-swap-horizontal</v-icon>
        Перевести на следующий год
      </v-btn>
    </template>

    <v-card>
      <v-card-title>Перевод контингента на следующий учебный год</v-card-title>

      <v-card-text>
        <p>
          Будет выполнен перевод всего контингента обучающихся на следующий
          учебный год. В ходе операции:
        </p>
        <ol class="pl-4">
          <li>
            Обучающиеся выпускных учебных групп будут переведены в архив, а в их
            описание будет добавлена пометка «(вып. {{ currentYear }})».
          </li>
          <li>
            Для переведённых в архив обучающихся будут созданы задачи
            синхронизации СКУД (блокировка пропусков на контроллерах).
          </li>
          <li>Выпускные учебные группы будут переведены в архив.</li>
          <li>
            Оставшиеся учебные группы будут переведены на следующий курс.
          </li>
        </ol>
        <p class="red--text">
          Операция необратима и затрагивает обучающихся всех факультетов.
        </p>
      </v-card-text>

      <v-card-actions>
        <v-spacer />
        <v-btn color="red" text @click="close">Отмена</v-btn>
        <v-btn :disabled="loading" color="primary" text @click="transfer">
          Подтвердить
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { transferPupilGroupsToNextYear } from "@/services/category.service";

export default {
  name: "TransferContingentDialog",

  data: () => ({
    show: false,
    loading: false,
  }),

  computed: {
    currentYear() {
      return new Date().getFullYear() % 100;
    },
  },

  methods: {
    close() {
      this.show = false;
    },

    async transfer() {
      this.loading = true;
      try {
        const result = await transferPupilGroupsToNextYear();

        this.$notify({
          text: `Перевод выполнен: в архив переведено обучающихся — ${result.archivedUsers}, групп — ${result.archivedGroups}; переведено на следующий курс групп — ${result.updatedGroups}; обновлено описаний обучающихся — ${result.updatedUsers}`,
          type: "success",
        });

        this.$emit("update");
      } catch (e) {
        this.$notify({
          text: e.response ? e.response.data.message : e,
          type: "error",
        });
      } finally {
        this.loading = false;
        this.close();
      }
    },
  },
};
</script>
